import {action, observable} from 'mobx'
import {Charts} from 'Store/charts'
import {Messages} from './messages'

export class TickerDetails extends Charts {
  @observable ticker
  @observable id
  @observable single = {data:{},algo:{}}
  @observable metrics = []

  constructor(props) {
    super(props)
    this.type = 'backtests'
    this.messages = new Messages(this.root, this.api)
  }

  @action setValues(vals) {
    for (let name in vals) {
      this[name] = vals[name]
    }
  }

  @action getData() {
    const {id, ticker} = this
    this.fetchCombined(id, ticker)
    this.fetchPnl(id, ticker)
    this.fetchIndicators(id, ticker)
    this.root.backtest.fetchMetrics.apply(this, [id, ticker])
    this.messages.load(id, ticker)
  }
}
